module.exports = __webpack_public_path__ + "static/media/app_badge_roblox.beb3cd83.png";